import React from 'react'
import {Card, Divider, Image, List, Space, Tag} from 'antd'
import {useRouteLoaderData} from 'react-router-dom'
import {News} from '../../entities/news'
import './news.less'
import Markdown from 'react-markdown'
import {hastToReact} from 'property-information'
import urlProjectPhoto0 from 'url:../../../public/assets/images/image1.jpg'
import {CalendarOutlined, RightOutlined} from '@ant-design/icons'
import dayjs from 'dayjs'
import {useIntl} from 'react-intl'
hastToReact['src']

export function NewsPage() {
  const {news, newsList} = useRouteLoaderData('news') as {
    news: News
    newsList: News[]
  }

  const intl = useIntl()

  return (
    <div className="news-page home-layout__content">
      <div className="news-page__text">
        <img
          style={{minWidth: '100%', height: 200, objectFit: 'cover'}}
          alt="image"
          src={news.titlePhotoURL ? news.titlePhotoURL : urlProjectPhoto0}
        />
        <h1>{intl.locale === 'en' ? news.newsName : news.newsNameRU}</h1>
        <div style={{color: 'rgba(0,0,0,0.45)'}}>
          <CalendarOutlined />
          <span style={{marginLeft: '10px'}}>{dayjs(news.dateOfCreating).format('ll')}</span>
        </div>
        <Markdown className="news-page__text__description" skipHtml={true}>
          {intl.locale === 'en' ? news.text : news.textRU}
        </Markdown>
      </div>
      <div className="news-page__list">
        <Card
          className="news-page__list__card"
          title={intl.formatMessage({id: 'otherNews'})}
          styles={{
            header: {borderBottom: '1px solid #f0f0f0'},
            body: {paddingTop: 16},
          }}
          cover={<div className="news-page__list__card__orange-stripe" />}
        >
          <List
            dataSource={newsList}
            split
            renderItem={(item) => (
              <List.Item style={{padding: '14px 0'}}>
                <List.Item.Meta
                  avatar={
                    <Image
                      src={item.titlePhotoURL}
                      alt={item.newsName}
                      width={72}
                      height={72}
                      preview={false}
                      style={{
                        borderRadius: 8,
                        objectFit: 'cover',
                      }}
                    />
                  }
                  title={
                    <a
                      href={`/home/news/${item.url}`}
                      style={{
                        color: 'rgba(0,0,0,0.88)',
                        fontWeight: 600,
                        lineHeight: 1.25,
                        display: 'inline-block',
                      }}
                    >
                      {intl.locale === 'en' ? item.newsName : item.newsNameRU}
                    </a>
                  }
                  description={
                    <div>
                      <div style={{color: 'rgba(0,0,0,0.45)'}}>
                        <CalendarOutlined />
                        <span style={{marginLeft: '10px'}}>
                          {dayjs(item.dateOfCreating).format('ll')}
                        </span>
                      </div>

                      <Tag className="news-page__list__card__news-tag">
                        {intl.formatMessage({id: `tag-${item.newsType}`})}
                      </Tag>

                      {(item.tags || []).map((t) => (
                        <Tag
                          key={t.id}
                          className="news-page__list__card__news-tag"
                          style={{color: t.color ? t.color : '#f58153'}}
                        >
                          {intl.locale === 'en' ? t.tagName : t.tagNameRu}
                        </Tag>
                      ))}
                    </div>
                  }
                />
              </List.Item>
            )}
          />

          <Divider style={{margin: '12px 0'}} />

          <a className="news-page__list__card__to-all" href="/home/news">
            {intl.formatMessage({id: `allNews`})}
            <RightOutlined style={{paddingLeft: '5px'}} />
          </a>
        </Card>
      </div>
    </div>
  )
}
